import { DropdownMenu } from '@ui-components/neo.tax';
import range from 'lodash/range';
import * as React from 'react';

import { useUpdateCompanyQuestion } from '@neo.tax/shared';

import { QuestionProps } from './company-info.types';

export const DropdownFieldYear: React.FC<QuestionProps> = ({ question, taxYear }) => {
  const updateCompanyQuestion = useUpdateCompanyQuestion(question.id, question.questionId);

  const options = range(1970, taxYear)
    .reverse()
    .map((year) => year.toString());
  return (
    <DropdownMenu
      options={options}
      value={question.answerValue ?? undefined}
      onChange={(newValue: string): void => {
        updateCompanyQuestion({ answerValues: newValue });
      }}
    />
  );
};
